import React from 'react';

import ChangeBadge from '../change-badge';

import type { ChangeValue } from '../../results-step.types';

import { Stack } from 'ui/stack';

interface NewAdmitsBadgeProps {
  newAdmits: ChangeValue | null;
}

const NewAdmitsBadge = ({
  newAdmits,
}: NewAdmitsBadgeProps): React.JSX.Element | null => {
  if (!newAdmits) return null;

  return (
    <Stack
      direction="row"
      data-testid="admit-new-admits"
      sx={{ alignItems: 'center', gap: 0.5 }}
    >
      <span className="text-sm text-gray-700">New admits:</span>
      <ChangeBadge
        change={newAdmits}
        variant="total"
        data-testid="admit-new-admits-value"
      />
    </Stack>
  );
};

export default NewAdmitsBadge;
